import React from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Autocomplete from "react-google-autocomplete";

const EnquiryTen = ({ handleSwithCases, setFieldValue, errors, touched, values }) => {
  return (
    <>
      <div>
        <div className="account-created-pop">
          <h3>Your Location</h3>
          <p>Tell us the city or town where the job is based</p>
          <Row>
            <Col lg={12} className="mx-auto">
              {/* City or Town Autocomplete */}
              <Form.Group className="mb-3 cmn-form-set" controlId="formBasicLocation">
                <Form.Label>City or Town</Form.Label>
                <Autocomplete
                  apiKey="AIzaSyBbvuzwkAMflFBj3Po5oybfHCAjejwj6ww"
                  onPlaceSelected={(place) => {
                    const lat = place.geometry?.location?.lat();
                    const lng = place.geometry?.location?.lng();
                    setFieldValue("city", place?.formatted_address); 
                    setFieldValue("latitude", lat|| 0);
                    setFieldValue("longitude", lng || 0);

                  }}
                  options={{
                    types: ["(cities)"],
                    componentRestrictions: { country: "gb" },
                  }}
                  defaultValue={values.city}
                  placeholder="Search here"
                  className={`form-control ${touched.city && errors.city ? 'is-invalid' : ''}`}
                />
                {touched.city && errors.city && (
                  <div className="text-danger">{errors.city}</div>
                )}
              </Form.Group>

              {/* Link to Search by Post Code */}
              <div className="step-link-step" onClick={handleSwithCases}>
                <Link to="">Search by Post Code instead</Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default EnquiryTen;
